import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-todays-tickets',
  templateUrl: './todays-tickets.component.html',
  styleUrls: ['./todays-tickets.component.css']
})
export class TodaysTicketsComponent implements OnInit {

  constructor(private userService: UserService,private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.GetTodaysTickets();
  }

  GetTodaysTickets = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getTodaysTickets()
    .subscribe((data:any)=>{
      this.TicketsList = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });
}
}



// WEBPACK FOOTER //
// ./src/app/reports/todays-tickets/todays-tickets.component.ts